module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/waiting/waiting.component.css
// module id = ./src/app/components/waiting/waiting.component.css
// module chunks = main